export default __webpack_public_path__ + "static/Montserrat-Italic-VariableFont_wght-7451547bd28d8dddbeea6973f92850f8.ttf";